import { render } from "./SidebarTabs.vue?vue&type=template&id=adec603c&scoped=true"
import script from "./SidebarTabs.vue?vue&type=script&lang=js"
export * from "./SidebarTabs.vue?vue&type=script&lang=js"

import "./SidebarTabs.vue?vue&type=style&index=0&id=adec603c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adec603c"]])

export default __exports__